import React, { useContext, useState } from "react"
import { useLocation } from 'react-router-dom';

// Queries
import { UserContext } from "../../context/userContext"
import { Link } from "react-router-dom"
import TRChatMessagesIndex from "./ChatMessages/TRChatMessagesIndex"
import AppBreadcrumb from "../../components/AppBreadcrumb/AppBreadcrumb"

export default function TelerecoveryServices() {
  const userCtx = useContext(UserContext)
  const location = useLocation();
  const [staffFullName, setStaffFullName] = useState(null)
  const [staffId, setStaffId] = useState(null)
  const [peerId, setPeerId] = useState(null)

  // Track which panel is active (list or chat) for mobile
  const [activePanel, setActivePanel] = useState("list") // "list" (default) or "chat"

  const changeSelectedConv = (newStaffFullName) => {
    setStaffFullName(newStaffFullName)
    setActivePanel("chat") // Switch to chat view

    // Conversation changed - clear peerId
    setPeerId(null)
  }

  React.useEffect(() => {
    if (location?.state?.peerId) {
      setPeerId(location.state.peerId)
    }
  }, [location])

  React.useEffect(() => {
    if (userCtx.staff_assignment_list) {
      let staff = Array.from(userCtx.staff_assignment_list)[0]
      setStaffId(staff.staff_id)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="main-content">
      <AppBreadcrumb
        items={[
          {
            template: (
              <Link
                to="/telerecovery"
                onClick={(e) => {
                  e.preventDefault()
                  setActivePanel("list") // Switch back to the list view
                }}
                style={{
                  color: "#873CAA",
                  fontSize: "16px",
                  lineHeight: "21.79px",
                  fontWeight: "400",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
              >
                Telerecovery
              </Link>
            ),
          },
          staffFullName && {
            label: staffFullName // Show the staff member's name
          },
        ].filter(Boolean)} // Remove undefined values
      />
      <div className="w-full pb-5">
        <h1 className="pageTitle">Telerecovery</h1>
        <hr className="line" />
        <div className="innerContent" style={{ marginTop: "25px" }}>
          {
            staffId && <TRChatMessagesIndex
              staffId={staffId}
              staffName={staffFullName}
              selectedConvStaffId={peerId}
              changeSelectedConv={changeSelectedConv}
              activePanel={activePanel} // Pass active panel state
              setActivePanel={setActivePanel} // Allow child to update panel state
            />
          }
        </div>
      </div>
    </div>
  )
}
